import React, { Component } from 'react';
import { connect } from 'react-redux';

import cx from 'classnames';
import moment from 'moment';
import {
  Field,
  Form,
  reduxForm,
} from 'redux-form';
import {
  birthdayDateAgeMajority,
  clubPrem,
  countryCode,
  firstName,
  enrollmentEmail,
  lastName,
  middleName,
  password,
  phoneNumberSignUpProfile,
  telephonePIN,
} from '../../validation/validation';
import { checkIsCountryEU } from '../../utilities/form-helpers';

import FormInputDateDropdown from '../global/form-input-date-dropdown';
import FormInputCheckbox from '../global/form-input-checkbox';
import Btn from '../global/button';
import formFieldCopyIDs from '../../constants/form-field-copy-ids';
import TranslatedCopy from '../../intl/translated-copy';
import FormInputText from '../global/form-input-text';
import FormInputDropdown from '../global/form-input-dropdown';
import FormInputPhone from '../global/form-input-phone';
import FormInputDatalist from '../global/form-input-datalist';
import Pictogram from '../global/pictogram';
import Tooltip from '../global/tooltip';
import userProfileSignupValidation from '../../validation/user-profile-signup-validation';
import {
  userProfileRegistrationEmailValidationAction,
  userProfileRegistrationTutorValidationAction,
  userProfileRegistrationValidateTutorStart,
} from '../../../redux/actions';
import { USER_PROFILE_SIGNUP_FORM_ID } from '../../constants/form-ids';
import { get } from 'lodash';

const mapStateToProps = state => {
  return ({
    contentForm: state.form[USER_PROFILE_SIGNUP_FORM_ID],
    countryContent: state.Countries.countryContent,
    duplicateEmailEnrollment: state.Login.duplicateEmailEnrollment,
    duplicateTutorEnrollment: state.Login.duplicateTutorEnrollment,
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    storefront: state.Manage.storefront,
    gralState: state,
  });
};

class UserProfileRegistrationCP extends Component {
  constructor(props) {
    super(props);
    this.renderSignUpFields = this.renderSignUpFields.bind(this);
    this.renderPasswordFields = this.renderPasswordFields.bind(this);
    this.renderAgree = this.renderAgree.bind(this);
    this.renderTelephonePIN = this.renderTelephonePIN.bind(this);
    this.state = {
      showCountryBannerAlertEU: false,
      showParentFFN: false,
    };
    this.inputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      contentForm: {
        values,
      },
      dispatch,
    } = this.props;

    const {
      contentForm: prevContentForm,
    } = prevProps;

    const {
      showParentFFN,
    } = this.state;

    const prevBirthdayDate = get(prevContentForm, 'values.birthdayDate', null);
    if ((values && values.birthdayDate && prevBirthdayDate !== values.birthdayDate) && typeof values.birthdayDate === 'string') {
      const actualDate = moment(moment.now()).format('YYYY-MM-DD');
      const selectedDate = moment(moment(values.birthdayDate, 'YYYY-MM-DD')).format('YYYY-MM-DD');
      const difference = moment(actualDate).diff(moment(selectedDate), 'years');

      if (difference < 18) {
        this.setState({ showParentFFN: true });
      } else {
        this.setState({ showParentFFN: false });
      }
      if (showParentFFN) {
        dispatch(userProfileRegistrationValidateTutorStart());
      }
    }
    // for country check
    const prevCountryCode = get(prevContentForm, 'values.countryCode', null);

    if (values?.countryCode && prevCountryCode !== values.countryCode) {
      this.setState({ showCountryBannerAlertEU: checkIsCountryEU(values.countryCode) });
    }
  }

  render() {
    const {
      contentForm,
      duplicateEmailEnrollment,
      duplicateTutorEnrollment,
      onSignupSubmit,
    } = this.props;

    if (duplicateEmailEnrollment?.value && duplicateEmailEnrollment?.value === contentForm?.values?.email) {
      contentForm.syncErrors.email = duplicateEmailEnrollment.copyID;
    } else {
      if (contentForm?.syncErrors?.email) {
        contentForm.syncErrors.email = enrollmentEmail(contentForm?.values?.email);
      }
    }

    if (duplicateTutorEnrollment?.value && duplicateTutorEnrollment?.value === contentForm?.values?.parent) {
      contentForm.syncErrors.parent = duplicateTutorEnrollment.copyID;
    } else {
      if (contentForm?.syncErrors?.parent) {
        contentForm.syncErrors.parent = clubPrem(contentForm?.values?.parent);
      }
    }

    const formClass = cx({
      'UserProfileSignup-form UserProfileRegistrationCP': true,
      'is-updating': false,
    });

    return (
      <Form
        className={ formClass }
        onSubmit={ onSignupSubmit }
      >
        { this.renderSignUpFields() }
        { this.renderTelephonePIN() }
        { this.renderPasswordFields() }
        { this.renderAgree() }
        <section className='UserProfileSignup-section UserProfileSignup-disclaimer'>
          { this.renderSubmitButton() }
        </section>
      </Form>
    );
  }

  renderSignUpFields() {
    const {
      countryContent,
      helperTraslatedCopy,
    } = this.props;

    const {
      showCountryBannerAlertEU,
    } = this.state;

    const genderOptions = [
      { copyID: '', value: '' },
      { copyID: 'PAX_MALE', value: 'M' },
      { copyID: 'PAX_FEMALE', value: 'F' },
      { copyID: 'PAX_OTHER', value: 'other' },
    ];

    return (
      <section className='UserProfileSignup-section'>
        {/* Email Field for Registration */}
        <Field
          autocompleteName='nope'
          className='FormInput-wrapper FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
          component={ FormInputText }
          isRequired={ true }
          key='inputEmail'
          label={ this.renderTextInputLabel({ name: 'email', formFieldCopyID: 'userProfileEmail' }) }
          name='email'
          onBlur={() => { this.handleEmailOnBlur(); }}
          showIconInput={ true }
          validate={ enrollmentEmail } />
        {/* FirstName Field for Registration */}
        <Field
          className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
          component={ FormInputText }
          isNameField={ true }
          isRequired={ true }
          key='inputFirstName'
          label={ this.renderTextInputLabel({ name: 'firstName', formFieldCopyID: 'firstNames' }) }
          maxLength={ 24 }
          name='firstName'
          showIconInput={ true }
          validate={ firstName }
        />
        {/* Paternal Surname(Last Name) Field for Registration */}
        <Field
          className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
          component={ FormInputText }
          isNameField={ true }
          isRequired={ true }
          key='inputLastName'
          label={ this.renderTextInputLabel({ name: 'lastName', formFieldCopyID: 'lastNameRegister' }) }
          maxLength={ 32 }
          name='lastName'
          showIconInput={ true }
          validate={ lastName }
        />
        {/* Maternal Surname(Middle Name) Field for Registration */}
        <Field
          className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
          component={ FormInputText }
          isNameField={ true }
          isRequired={ true }
          key='inputMiddleName'
          label={ this.renderTextInputLabel({ name: 'middleName', formFieldCopyID: 'userProfileMiddleNameCP' }) }
          maxLength={ 30 }
          name='middleName'
          showIconInput={ true }
          validate={ middleName }
        />
        {/* Date of Birth Field for Registration */}
        <Field
          autocompleteGroupName='bday'
          className='FormInput-wrapper FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-birthdayDate'
          component={ FormInputDateDropdown }
          helperTraslatedCopy={ helperTraslatedCopy }
          isRequired={ true }
          key='inputBirthdayDate'
          label={ this.renderTextInputLabel({ name: 'birthdayDate', formFieldCopyID: 'dateOfBirth' }) }
          labelClassModifier='BirthDay'
          monthsInNumbers={ true }
          name='birthdayDate'
          setStateOnUpdate={ true }
          validate={ birthdayDateAgeMajority }
          withDivider={ true }
        />
        {/* Telephone Field for Registration */}
        <Field
          autocomplete={ false }
          className='FormInput-wrapper FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home UserProfileSignUp-telefono UserEnrollmentPhone'
          component={ FormInputPhone }
          countryContent={ countryContent }
          inputClassModifier={ ['large', 'phone'] }
          isRequired={ true }
          key='inputPhone'
          label={ this.renderTextInputLabel({ name: 'phone', formFieldCopyID: 'billingPhone' }) }
          labelCopyID={ formFieldCopyIDs.billingPhone }
          name='phone'
          showIconInput={ true }
          validate={ phoneNumberSignUpProfile }
        />
        {/* Country of Residence field */}
        <Field
          component={ FormInputDatalist }
          countrySuggestion={ this.handleCountrySuggestion() }
          inputClassModifier='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-country'
          isEnrollmentModal={ true }
          isRequired={ true }
          labelCopyID={ formFieldCopyIDs.countryCode }
          name='countryCode'
          options={ this.handleCountryOption() }
          shouldSetErrorWidth={ true }
          validate={ countryCode }
        />
        { showCountryBannerAlertEU &&
          this.rendershowCountryBannerAlertEU()
        }
        {/* Gender Field for Registration*/}
        <Field
          className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home UserProfile-Gender'
          component={ FormInputDropdown }
          inputClassModifier='large'
          key='inputGender'
          label={ this.renderTextInputLabel({ name: ' gender', formFieldCopyID: 'gender' }) }
          name='gender'
          options={ genderOptions } />
      </section>
    );
  }

  handleCountrySuggestion = () => {
    const { storefront, countryContent } = this.props;
    const storefrontSplit = storefront.split('-')[1];
    const sfMex = 'mx';
    const sfUs = 'us';
    const isMx = storefrontSplit === sfMex;
    const countryMx = countryContent.find(el => el.value === sfMex.toUpperCase());
    const dataList = [];

    if (storefrontSplit === 'eu') {
      return dataList;
    } else if (isMx || storefrontSplit === sfUs) {
      const countryUs = countryContent.find(el => el.value === sfUs.toUpperCase());
      const countryList = isMx ? [countryMx, countryUs] : [countryUs, countryMx];

      return countryList.filter(el => el !== undefined);
    } else {
      const country = countryContent.find(el => el.value === storefrontSplit.toUpperCase());

      return [country, countryMx].filter(el => el !== undefined);
    }
  }

  handleCountryOption = () => {
    const { countryContent } = this.props;

    const [ firstCountry, secondCountry ] = this.handleCountrySuggestion();
    const skipCountry = [
      firstCountry && firstCountry.value,
      secondCountry && secondCountry.value,
    ];

    return countryContent.filter(el => !skipCountry.includes(el.value));
  }

  renderPasswordFields() {
    return (
      <Field
        className='LoginModalForm-formInput LoginModalForm-formInput--password UserProfileLogin-formInput UserProfileLoginForm-home'
        component={ FormInputText }
        errorClassName={ 'PnrInput-error' }
        errorMessageData={ this.errorPassword }
        inputClassModifier='passwordInput'
        isRequired={ true }
        key='inputPasswordReg'
        label={ this.renderTextInputLabel({ name: 'SignUpPassword', formFieldCopyID: 'passwordLabel', tooltipCopyID:formFieldCopyIDs.passwordTooltip }) }
        name='SignUpPassword'
        passwordRegistrationModal={ true }
        showIcon={ true }
        tooltipCopyID={ formFieldCopyIDs.passwordTooltip }
        type={ 'password' }
        validate={ password }
      />
    );
  }

  renderTelephonePIN() {
    const {
      helperTraslatedCopy,
    } = this.props;

    return (
      <Field
        className='LoginModalForm-formInput LoginModalForm-formInput--password UserProfileLogin-formInput UserProfileLoginForm-home UserLoginPasswordWrapper'
        component={ FormInputText }
        errorClassName={ 'PnrInput-error' }
        errorMessageData={ this.errorPassword }
        inputClassModifier='passwordInput'
        isRequired={ true }
        label={ this.renderTextInputLabel({
          formFieldCopyID: 'telephonePIN',
          name: 'telephonePIN',
          tooltipCopyID:formFieldCopyIDs.telephonePINTooltip,
        }) }
        maxLength={ 4 }
        name='telephonePIN'
        passwordRegistrationModal={ true }
        placeholder={ helperTraslatedCopy.getFormatMessageFromcopyId(formFieldCopyIDs.userProfileTelephonePinPlaceholder) }
        showIcon={ true }
        tooltipCopyID={ formFieldCopyIDs.telephonePINTooltip }
        type={ 'password' }
        validate={ telephonePIN }
      />
    );
  }

  renderAgree() {
    return (
      <section className='UserProfileRegistrationCP-checkouts'>
        <Field
          className='FormInput--checkbox FormInput--full'
          component={ FormInputCheckbox }
          fieldLabel={ <TranslatedCopy copyID={ formFieldCopyIDs.userProfileTermsAndConditions } /> }
          inputClassModifier={ ['checkbox', 'full'] }
          isRequired={ true }
          labelClassModifier='checkbox'
          name='userProfileTermsAndConditions' />
        <Field
          className='FormInput--checkbox FormInput--full'
          component={ FormInputCheckbox }
          fieldLabel={ <TranslatedCopy copyID={ formFieldCopyIDs.userProfilePrivacyPolicy } /> }
          inputClassModifier={ ['checkbox', 'full'] }
          isRequired={ true }
          labelClassModifier='checkbox'
          name='privacyPolicy' />
      </section>
    );
  }

  renderSubmitButton() {
    const {
      handleSubmit,
      invalid,
      onSignupSubmit,
    } = this.props;

    return (
      <Btn
        block={ true }
        btnType='submit'
        className='Btn--filledRed'
        copyID='APP_SIGNUP_TITLE'
        filled={ true }
        onBtnClick={ handleSubmit(onSignupSubmit) }
        visuallyDisabled ={ invalid }
      />
    );
  }

  renderParentGuardianAuthBanner() {
    return (
      <>
      <div className='Form-ParentGuardian-Banner'>
        <div className='Form-ParentGuardian-Banner-header'>
          <Pictogram
            className='Form-ParentGuardian-Banner-header-logo'
            id='parentGuardianBannerIcon'
          />
          <div className='Form-ParentGuardian-Banner-header-text'>
            <TranslatedCopy
              copyID={ formFieldCopyIDs.parentBannerTitle }
              id={ 'parentesco-banner-header-text' }
              spaceAfter={ true } />
          </div>
        </div>
        <div className='Form-ParentGuardian-Banner-body'>
          <TranslatedCopy
            copyID={ formFieldCopyIDs.parentBannerText }
            id={ 'parentesco-banner-header-body' }
            spaceAfter={ true } />
        </div>
      </div>
      <Field
        className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
        component={ FormInputText }
        isRequired={ true }
        key='inputTutor'
        label={
          <TranslatedCopy
            copyID={ formFieldCopyIDs.parentLabel }
            id={ 'parentesco-label' }
            spaceAfter={ true } />
        }
        labelClassModifier='TutorLabel'
        maxLength={ 11 }
        minLength={ 1 }
        name='parent'
        onBlur={() => { this.handleTutorOnBlur(); }}
        showIconInput={ true }
        validate={ clubPrem } />
      </>
    );
  }

  rendershowCountryBannerAlertEU() {
    return (
      <div className='CountryBannerAlertEU'>
        <div className='FormInput--checkbox CountryBannerAlertEU-checkbox'>
          <Field
            component={ FormInputCheckbox }
            name='isCountryEU'
            label={ false }
            labelCopyID={ false } />
        </div>
        <div className='CountryBannerAlertEU-text'>
          <TranslatedCopy
            copyID={ formFieldCopyIDs.isCountryEU }
            spaceAfter={ true } />
        </div>
      </div>
    );
  }

  renderTextInputLabel(input) {
    return (
      input.formFieldCopyID &&
      <div>
        <TranslatedCopy
          copyID={ formFieldCopyIDs[input.formFieldCopyID] } // PRO_HOME2.0_LAST_NAME
          id={ `${input.name}-label` }
          spaceAfter={ true } />
        { input.tooltipCopyID &&
          <Tooltip
            copyID={ input.tooltipCopyID }
            labelID={ `${input.name}-label` }
            light={ false }
            loginRegistrationClassNames = 'TooltipLoginModal'
            position={ {
              'small': 'bottom',
              'medium': 'bottom',
              'medium-high': 'bottom',
              'large': 'bottom',
            } }
            tooltipID={ `${input.name}-tooltip` } />
        }
      </div>
    );
  }

  handleEmailOnBlur() {
    const {
      contentForm: {
        values,
      },
      dispatch,
      gralState,
    } = this.props;

    dispatch(userProfileRegistrationEmailValidationAction(values?.email, gralState));
  }

  handleTutorOnBlur() {
    const {
      contentForm: {
        values,
      },
      dispatch,
      gralState,
    } = this.props;

    dispatch(userProfileRegistrationTutorValidationAction({
      guardianAccount: values?.parent,
      email: values?.email,
      birthdayDate: values?.birthdayDate,
    }, gralState));
  }
}

UserProfileRegistrationCP = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_SIGNUP_FORM_ID,
  validate: userProfileSignupValidation,
})(UserProfileRegistrationCP);

UserProfileRegistrationCP = connect(mapStateToProps)(UserProfileRegistrationCP);

export default UserProfileRegistrationCP;